import { identifyYandehSso } from '../services/loginApi'

const submitSamlForm = (acsUrl: string, samlResponse: string) => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = acsUrl

  const samlResponseInput = document.createElement('input')
  samlResponseInput.type = 'hidden'
  samlResponseInput.name = 'SAMLResponse'
  samlResponseInput.value = samlResponse

  form.appendChild(samlResponseInput)
  document.body.appendChild(form)
  form.submit()
}

export const redirectToAbasteceShopWithSso = async (merchantCode?: string) => {
  if (!merchantCode) {
    console.log('[AbasteceShop SSO] merchantCode ausente.')
    return false
  }

  try {
    const response = await identifyYandehSso(merchantCode)
    const yandehSso = response.yandehSso

    if (!yandehSso) {
      console.log('[AbasteceShop SSO] yandeh_sso ausente no retorno.')
      return false
    }

    const { acsUrl, samlResponse } = yandehSso

    if (!acsUrl || !samlResponse) {
      console.log('[AbasteceShop SSO] acs_url ou saml_response ausente no retorno.')
      return false
    }

    submitSamlForm(acsUrl, samlResponse)
    return true
  } catch (error) {
    console.log('Error redirecting to AbasteceShop', error)
    return false
  }
}
